<script setup lang="ts">
import BaseButton from "./BaseButton.vue";
import BaseDialog from "./BaseDialog.vue";
import { useConfirmation } from "../composables/useConfirmation";

const confirmation = useConfirmation();
</script>

<template>
  <BaseDialog :is-open="confirmation.state.isOpen" size="small" :title="confirmation.state.title"
    :description="confirmation.state.message" @close="confirmation.resolve(false)">
    <template #actions>
      <div class="flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:justify-end">
        <BaseButton variant="ghost" class="w-full justify-center sm:w-auto" @click="confirmation.resolve(false)">
          {{ confirmation.state.cancelText }}
        </BaseButton>
        <BaseButton class="w-full justify-center sm:w-auto" @click="confirmation.resolve(true)">
          {{ confirmation.state.confirmText }}
        </BaseButton>
      </div>
    </template>
  </BaseDialog>
</template>
